// src/components/inventory/transfer/columns/pendingTransferColumns.ts

import { CustomColumn } from "../../../../types/customColumn";
import { InventoryTransferTableDTO } from "../../../../types/inventory/transfer/InventoryTransferTypes";

export const pendingTransferColumns: CustomColumn<InventoryTransferTableDTO>[] = [
  { Header: "Productos", accessor: "productCount" },
  { Header: "Origen", accessor: "originBranchName" },
  { Header: "Destino", accessor: "destinationBranchName" },
  { Header: "Fecha", accessor: "requestedDate" },
  { Header: "Hora", accessor: "requestedTime" },

  // Estado sin badge, solo texto plano
  {
    Header: "Estado",
    accessor: "status",
    customCell: ({ row }) => (
      <span className="text-sm text-gray-700 dark:text-gray-300 font-medium">
        {row.original.status}
      </span>
    ),
  },
];
